// Links, die den Shop verlassen, in neuem Tab oeffnen (#289).
//
// Warum ein Skript statt target="_blank" im Markup: externe Links stehen an
// vielen Stellen, auch in Inhalten aus dem Theme-Editor (Menues, Rich-Text,
// Video-Sections). Die kann man nicht einzeln patchen, und jeder neue Link waere
// wieder falsch. Der Click-Handler sitzt auf document (Capture-Phase) und greift
// deshalb auch fuer Links, die erst spaeter per JS eingefuegt werden.
(function () {
  // www.hobbyhorsingworld.de und hobbyhorsingworld.de zaehlen als derselbe Shop.
  var bare = function (host) { return host.replace(/^www\./, ''); };
  var own = bare(location.hostname);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return; // mailto:, tel:, javascript:
    if (bare(link.hostname) === own) return;

    link.target = '_blank';
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    link.setAttribute('rel', rel.join(' '));
  }, true);
})();
